module.exports = __webpack_public_path__ + "static/media/cms.c8dcbed4.png";